import React from "react";
import PicMD from "../PicMD";
import LoadingIndicator from "./Loading";

const Ray = () => {
  return (
    <div>
      <PicMD doctor="Ray" />
      <strong>Meet Dr. Milton Ray</strong>
      <br />
      <br />
      <p><LoadingIndicator /></p>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Ray;
